import styled, { keyframes } from 'styled-components';
import LoaderIcon from '../../../assets/svg/loader.svg';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Loader = styled(LoaderIcon)`
  display: block;
  width: 20px;
  height: 20px;
  animation: ${rotate} 1s linear infinite;
`;

export default Loader;
